/* BRINUTI – a választott belív be van karikázva a Teeinblue-galéria „Válassz 6 féle
   belív közül!” képén (2026-10-27, a tulaj kérése: „amelyik ki van választva, az
   legyen bekarikázva, hogy ezt választottad”; asztalon és mobilon is).

   A kép (a galéria 4. diája, Teeinblue-mockup: 260921_O4wJmxk6YgOAbOTB) egy 1024 × 1024-es
   fix elrendezés, a hat belív mindig ugyanott van. A kiemelő keret ezért a mockup
   százalékos koordinátáira kerül, így minden szélességen pontosan a belív körül áll.
   A választott belívet a Teeinblue-űrlap legördülőjéből olvassuk (ugyanazt a mezőt,
   amelyet a belívválasztó kártya is kezel – snippets/brinuti-tee-valaszto.liquid), tehát
   a kártyás/paneles és a sima választás is ide vezet. A kosárból nyitott szerkesztőablakban
   a saját űrlapja számít (mint a szalagszínnél, assets/brinuti-szalag-mockup.js).
   A Teeinblue a galériát időnként újrarajzolja: a keretet ilyenkor újra odatesszük. */
(function () {
  if (window.__bvKiemeles) return;
  window.__bvKiemeles = true;

  var KEP = '260921_O4wJmxk6YgOAbOTB';
  /* A hat belív a képen: [bal, fent, jobb, lent] az 1024 × 1024-es képen, a belív képével
     és a felirattal együtt (a méréssel az eredeti képből: sorok 218–557 és 601–890). */
  var CELLA = {
    onismereti: [19, 206, 342, 569],
    hatarido: [351, 206, 671, 569],
    idopont: [677, 206, 999, 569],
    vonalas: [19, 589, 342, 902],
    pontracsos: [351, 589, 671, 902],
    sima: [677, 589, 999, 902]
  };
  /* A Teeinblue-opció szövegéből a belív: a sorrend számít (az „Időpontbeosztó” is
     tartalmazza a „pont” szót) – ugyanaz, mint a belívválasztóban. */
  var MINTA = [
    ['onismereti', /önismereti/i],
    ['hatarido', /határidő/i],
    ['idopont', /időpont/i],
    ['pontracsos', /pontrácsos|pontozott/i],
    ['vonalas', /vonalas/i],
    ['sima', /^\s*(üres|sima)\b/i]
  ];

  function kulcs(szoveg) {
    for (var i = 0; i < MINTA.length; i++) if (MINTA[i][1].test(szoveg)) return MINTA[i][0];
    return null;
  }

  var css = document.createElement('style');
  css.id = 'bv-kiemeles-stilus';
  css.textContent =
    '.bvk{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:6}' +
    '.bvk__keret{position:absolute;box-sizing:border-box;border:3px solid #1f1f1f;border-radius:16px;' +
    'background:rgb(255 255 255 / .14);box-shadow:0 3px 14px rgb(31 31 31 / .16);opacity:0}' +
    '.bvk--lathato .bvk__keret{opacity:1}' +
    '.bvk--mozog .bvk__keret{transition:left .28s ease,top .28s ease,width .28s ease,height .28s ease,opacity .2s ease}' +
    '.bvk__jel{position:absolute;left:50%;top:0;transform:translate(-50%,-50%);width:max-content;background:#1f1f1f;color:#fff;' +
    'font-family:var(--font-body--family,inherit);font-weight:600;line-height:1.25;padding:.2em .7em;border-radius:999px;' +
    'letter-spacing:.01em}' +
    '@media (prefers-reduced-motion:reduce){.bvk--mozog .bvk__keret{transition:none}}';
  document.head.appendChild(css);

  // A választott belív kulcsa az űrlapból; null: nincs választás; undefined: nincs ilyen mező.
  function valasztott(gyoker) {
    if (!gyoker) return undefined;
    var mezok = gyoker.querySelectorAll('.tee-field__input select');
    for (var i = 0; i < mezok.length; i++) {
      var sel = mezok[i], ismert = 0, ok = true;
      for (var j = 0; j < sel.options.length; j++) {
        var o = sel.options[j];
        if (o.disabled || !o.value || o.value === 'null') continue;
        if (!kulcs(o.text)) { ok = false; break; }
        ismert++;
      }
      if (!ok || ismert < 2) continue;
      var akt = sel.options[sel.selectedIndex];
      if (!akt || !akt.value || akt.value === 'null') return null;
      return kulcs(akt.text);
    }
    return undefined;
  }

  // Melyik űrlap tartozik a képhez: a szerkesztőablaké, egyébként a termékoldalé.
  function urlapA(mockup) {
    return mockup.closest('.tee-edit-popup') || document.getElementById('tee-artwork-form') ||
      document.getElementById('teeFormInputs') || document.querySelector('.tee-edit-popup');
  }

  function keretKeszit(mockup) {
    var kt = mockup.querySelector(':scope > .bvk');
    if (kt) return kt;
    kt = document.createElement('div');
    kt.className = 'bvk';
    kt.setAttribute('aria-hidden', 'true');
    kt.innerHTML = '<div class="bvk__keret"><span class="bvk__jel">✓ Választottad</span></div>';
    mockup.appendChild(kt);
    if (getComputedStyle(mockup).position === 'static') mockup.style.position = 'relative';
    // Az első kirajzolás mozgás nélkül, utána a váltás finoman csúszik.
    (window.requestAnimationFrame || setTimeout)(function () { kt.classList.add('bvk--mozog'); });
    return kt;
  }

  function allit() {
    var kepek = document.querySelectorAll('.tee-mockup .tee-printarea img');
    for (var i = 0; i < kepek.length; i++) {
      var k = kepek[i], cim = k.getAttribute('src') || '';
      if (cim.indexOf(KEP) < 0 && !/belivek/i.test(k.getAttribute('alt') || '')) continue;
      var mockup = k.closest('.tee-mockup');
      if (!mockup) continue;
      var kulcsa = valasztott(urlapA(mockup)), kt = mockup.querySelector(':scope > .bvk');
      var c = kulcsa && CELLA[kulcsa];
      if (!c) { if (kt) kt.classList.remove('bvk--lathato'); continue; }
      kt = keretKeszit(mockup);
      var keret = kt.firstChild, szel = mockup.getBoundingClientRect().width || 600;
      keret.style.left = (c[0] / 10.24) + '%';
      keret.style.top = (c[1] / 10.24) + '%';
      keret.style.width = ((c[2] - c[0]) / 10.24) + '%';
      keret.style.height = ((c[3] - c[1]) / 10.24) + '%';
      // A vonalvastagság, a sarok és a jelvény betűje a kép szélességéhez igazodik.
      keret.style.borderWidth = Math.max(2, Math.round(szel * 0.005)) + 'px';
      keret.style.borderRadius = Math.round(szel * 0.026) + 'px';
      keret.firstChild.style.fontSize = Math.max(11, Math.min(14, Math.round(szel * 0.022))) + 'px';
      kt.setAttribute('data-beliv', kulcsa);
      kt.classList.add('bvk--lathato');
    }
  }

  var utemezve = false;
  function utemez() {
    if (utemezve) return;
    utemezve = true;
    (window.requestAnimationFrame || setTimeout)(function () { utemezve = false; allit(); });
  }

  new MutationObserver(function (v) {
    for (var i = 0; i < v.length; i++) {
      // A saját keretünk beszúrása nem ébreszt újra (különben végtelen kör lenne).
      var n = v[i].addedNodes;
      if (n.length && !(n.length === 1 && n[0].className === 'bvk')) { utemez(); return; }
      if (v[i].type === 'attributes') { utemez(); return; }
    }
  }).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'selected', 'value']
  });
  document.addEventListener('change', utemez, true);
  document.addEventListener('input', utemez, true);
  document.addEventListener('click', function () { setTimeout(utemez, 60); }, true);
  window.addEventListener('resize', utemez);
  // A legördülő értékét a kártya/panel szkriptből is átírhatják esemény nélkül: biztonsági lekérdezés.
  setInterval(function () { if (document.querySelector('.tee-mockup')) allit(); }, 800);
  utemez();
})();
